import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as commonActions from '../../../../app/common/common.action';
import { bindActionCreators } from 'redux';
import {
    Button,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Jumbotron,
    Progress
} from 'reactstrap';
import CheckBox from '../../../../componentes/checkbox/checkbox.component';
import DateInput from '../../../../componentes/datepicker/react-datepicker.component';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import CitologiaApi from '../../../citologia/content/citologia.api'
import SelectComponent from '@componentes/select/select.component';
import NomeSocial from '@containers/NomeSocial';
import IntlMessage from "../../../../helpers/intlMessage";

class DelegacaoLaminasComponent extends Component {
    constructor() {
        super();
        this.NumeroExameRef = React.createRef();
        this.state = {
            laminas: [],
            numeroExame: '',
            idLaudolaminasChecked: [],
            citoTecnicos: [],
            citoTecnicoDelegado: null,
            totalLaminasDelegadasCitotecnico: null,
            limiteLaminasDelegadas: 23,
            data: new Date().toISOString().slice(0, 10)
        }
    }

    render() {
        let {
            laminas,
            numeroExame,
            citoTecnicos,
            citoTecnicoDelegado,
            totalLaminasDelegadasCitotecnico,
            data,
            limiteLaminasDelegadas
        } = this.state;

        let nomeCitotecnico = citoTecnicoDelegado !== null
            ? citoTecnicoDelegado.label : '';

        return (
            <div>
                <Row>
                    <Col>
                        <Jumbotron style={{ boxShadow: 'none', padding: 0 }}>
                            <span style={{ display: 'block', fontWeight: 700, marginBottom: '5px' }}>
                                <IntlMessage id = "dashboards.cytology.statusDelegation"/>
                                {`${nomeCitotecnico}`}
                            </span>
                            <Progress multi>
                                <Progress bar
                                    color="success"
                                    value={totalLaminasDelegadasCitotecnico}
                                    max={limiteLaminasDelegadas}>
                                    {totalLaminasDelegadasCitotecnico}
                                </Progress>
                                <Progress bar
                                    color="danger"
                                    value={limiteLaminasDelegadas - totalLaminasDelegadasCitotecnico}
                                    max={limiteLaminasDelegadas}>
                                    {limiteLaminasDelegadas - totalLaminasDelegadasCitotecnico}
                                </Progress>
                            </Progress>
                        </Jumbotron>
                    </Col>
                </Row>
                <Row>
                    <Col sm={'2'}>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.cytology.delegationDate"/></Label>
                            <DateInput
                                value={data}
                                onChange={(e) => {
                                    this.setState({ data: e });
                                    this.onChangeData(e);
                                }
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={'3'}>
                        <Label><IntlMessage id = "dashboards.cytology.numberExam"/></Label>
                        <Input
                            style={{ fontSize: '13px' }}
                            innerRef={this.NumeroExameRef}
                            value={numeroExame}
                            onChange={this.onChangeNumeroExame}
                            onKeyPress={(event) => {
                                if (event.key === "Enter" && event.currentTarget.value.trim().length > 0) {
                                    this.pesquisarLaminasCitologia();
                                }
                            }}
                        />
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label><IntlMessage id = "dashboards.cytology.delegationCytotechnician"/></Label>
                            <SelectComponent
                                options={citoTecnicos}
                                value={citoTecnicoDelegado}
                                onChange={(el) => {
                                    this.setState({ citoTecnicoDelegado: el });
                                    this.onChangeCitotecnico(el.value);
                                }}
                                placeholder={this.props.intl.formatMessage({ id:"dashboards.cytology.selectCytotechnician"})}
                                styles={{ borderColor: 'transparent' }}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm='auto'>
                        <Button
                            onClick={this.pesquisarLaminasCitologia.bind(this)}
                            className="delegacao-laminas-pesquisa"
                            color={!numeroExame ? "secondary" : "primary"}
                            disabled={!numeroExame}
                        >
                            <IntlMessage id = "dashboards.cytology.search"/>
                            </Button>
                    </Col>
                </Row>
                <br />
                <div className="delegacao-laminas-casos">
                    {
                        laminas.length > 0 && <Row className="thead">
                            <Col sm={'4'}><IntlMessage id = 'dashboards.taskControl.blade'/></Col>
                            <Col sm={'3'}><IntlMessage id = 'general.requestsPanel.date'/></Col>
                            <Col><IntlMessage id = 'general.requestsPanel.patient'/></Col>
                            <Col><IntlMessage id = 'dashboards.histology.responsibleCytotechnician'/></Col>
                        </Row>
                    }
                    <div className="delegacao-laminas-tbody">
                        {
                            laminas.map((el) => {
                                let checkboxDisabled =
                                    citoTecnicoDelegado !== null &&
                                    citoTecnicoDelegado.value === el.idCitoTecnicoDelegado;
                                return (
                                    <Row>
                                        <Col sm={'4'} key={el.idLamina}>
                                            <CheckBox
                                                disabled={checkboxDisabled}
                                                label={el.lamina}
                                                checked={this.state.idLaudolaminasChecked
                                                    .findIndex(ee => ee.idExterno === el.idExterno) >= 0}
                                                onChange={() =>
                                                    this.onChangeIdLaudolaminas(
                                                        el.idExterno, el.nmTabela, el.laudo
                                                    )}
                                            />
                                        </Col>
                                        <Col sm={'3'}>
                                            {el.dataDeCadastro}
                                        </Col>
                                        <Col>
                                        <NomeSocial id={el.idLamina} nome={el.paciente} social={el.pacienteNomeSocial} />
                                        </Col>
                                        <Col>
                                            {el.citoTecnicoDelegado}
                                        </Col>
                                    </Row>
                                )
                            })
                        }
                    </div>
                </div>
                <br />
                <Button
                    style={{ fontSize: '12px', marginRight: '8px' }}
                    disabled={
                        !this.state.idLaudolaminasChecked.length > 0 ||
                        this.state.totalLaminasDelegadasCitotecnico >= 23 ||
                        this.state.citoTecnicoDelegado === null
                    }
                    onClick={this.delegarLaminas.bind(this)}
                    color="primary">
                    <IntlMessage id = "dashboards.cytology.delegateBlades"/>
                </Button>
                <Button
                    style={{ fontSize: '12px' }}
                    disabled={!this.state.idLaudolaminasChecked.length > 0}
                    onClick={this.limparDelegacao.bind(this)}
                    color="danger">
                    <IntlMessage id = "dashboards.cytology.removeDelegation"/>
                </Button>
            </div>
        )
    }

    componentDidMount() {
        this.props.commonActions.showFadeCarregando(true);

        Promise.all([
            WebapiCommon.getCitotecnicos(),
            WebapiCommon.getConfiguracaoMapaMacroscopico()
        ]).then((res) => {
            let citoTecnicos = res[0].map((el) => ({
                value: el.segUsu_Id,
                label: el.nome
            }));

            this.setState({
                citoTecnicos,
                limiteLaminasDelegadas: res[1]
                    .configuracoesMapaMacroscopicoItems
                    .find(el => el.coluna === 'Limitelaminas').valor
            });
            this.props.commonActions.showFadeCarregando(false);
            this.NumeroExameRef.current.focus();

        })
    }

    pesquisarLaminasCitologia() {
        let { numeroExame } = this.state;

        this.props.commonActions.showFadeCarregando(true);

        WebapiCommon.getLaminasCitologia(0, '', '', numeroExame, '').then((res) => {
            this.setState({ laminas: res });
            this.props.commonActions.showFadeCarregando(false);

            if (res.length === 0) {
                this.props.commonActions.showAlerta(
                    "alerta", `${ this.props.intl.formatMessage({id:"dashboards.histology.noBladeFound"}) }`, 2000
                );
            }
        });
    }

    delegarLaminas() {
        this.props.commonActions.showFadeCarregando(true);
        let { idLaudolaminasChecked, citoTecnicoDelegado, data } = this.state;

        let laudoLaminas = idLaudolaminasChecked.filter(el => el.nmTabela === 'LAUDOLAMINAS');
        let idLaudolaminas = laudoLaminas.map(el => el.idExterno);

        let blocoLaminas = idLaudolaminasChecked.filter(el => el.nmTabela === 'LAUDOBLOCOSLAMINAS');
        let cdBlocolamina = blocoLaminas.map(el => el.idExterno);

        let laudo = laudoLaminas.length > 0 
            ? laudoLaminas.map(el => el.laudo)[0] : blocoLaminas.map(el => el.laudo)[0]

        CitologiaApi.delegarLaminaCitologia(
            idLaudolaminas, cdBlocolamina, citoTecnicoDelegado.value, data, laudo).then((res) => {
                this.setState({
                    laminas: [],
                    numeroExame: '',
                    idLaudolaminasChecked: [],
                    citoTecnicoDelegado: null,
                    totalLaminasDelegadasCitotecnico: null
                });

                this.props.commonActions.showFadeCarregando(false);
                this.props.commonActions.showAlerta(
                    "sucesso", `${ this.props.intl.formatMessage({id:"dashboards.histology.successfullyDelegatedBlade"}) }`, 1600
                );
            });
    }

    limparDelegacao() {
        this.props.commonActions.showFadeCarregando(true);
        let { idLaudolaminasChecked } = this.state;

        let laudoLaminas = idLaudolaminasChecked.filter(el => el.nmTabela === 'LAUDOLAMINAS');
        let idLaudolaminas = laudoLaminas.map(el => el.idExterno);

        let blocoLaminas = idLaudolaminasChecked.filter(el => el.nmTabela === 'LAUDOBLOCOSLAMINAS');
        let cdBlocolamina = blocoLaminas.map(el => el.idExterno);

        let laudo = laudoLaminas.length > 0 
            ? laudoLaminas.map(el => el.laudo)[0] : blocoLaminas.map(el => el.laudo)[0]

        CitologiaApi.delegarLaminaCitologia(idLaudolaminas, cdBlocolamina, 0, null, laudo).then((res) => {
            this.setState({
                laminas: [],
                numeroExame: '',
                idLaudolaminasChecked: [],
                citoTecnicoDelegado: null,
                totalLaminasDelegadasCitotecnico: null
            });

            this.props.commonActions.showFadeCarregando(false);
            this.props.commonActions.showAlerta(
                "sucesso", `${ this.props.intl.formatMessage({id:"dashboards.histology.successfullyCanceledDelegations"}) }`, 1600
            );
        });
    }

    onChangeNumeroExame = (el) => this.setState({
        numeroExame: el.currentTarget.value
    });

    onChangeIdLaudolaminas = (idExterno, nmTabela, laudo) => {
        let { idLaudolaminasChecked } = this.state;
        let index = idLaudolaminasChecked
            .findIndex(el => el.idExterno === idExterno);

        if (index >= 0) {
            idLaudolaminasChecked.splice(index, 1);
        }
        else {
            idLaudolaminasChecked.push({
                idExterno, nmTabela, laudo
            });
        }

        this.setState({ idLaudolaminasChecked });
    }

    onChangeCitotecnico(value) {
        let { data } = this.state;
        this.props.commonActions.showFadeCarregando(true);
        CitologiaApi.obterTotalLaminasDelegadasCitotecnico(data, value).then((res) => {
            this.setState({ totalLaminasDelegadasCitotecnico: res, idLaudolaminasChecked: [] });
            this.props.commonActions.showFadeCarregando(false);
        })
    }

    onChangeData(value) {
        let { citoTecnicoDelegado } = this.state;

        if (citoTecnicoDelegado !== null) {
            this.props.commonActions.showFadeCarregando(true);
            CitologiaApi.obterTotalLaminasDelegadasCitotecnico(value, citoTecnicoDelegado.value).then((res) => {
                this.setState({ totalLaminasDelegadasCitotecnico: res });
                this.props.commonActions.showFadeCarregando(false);
            })
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(DelegacaoLaminasComponent);


// WEBPACK FOOTER //
// ./src/pages/histologia/common/delegacao_laminas/delegacao.laminas.component.js